/**
 * Chat summary query operations - Update
 */

import { getSupabaseClient } from '../../supabase-client.js';
import type { ChatId } from '../../types.js';
import type { ChatSummary } from '../types.js';
import { logger } from '../../../logger.js';
import { mapChatSummaryRow, type ChatSummaryRow } from './row-mapper.js';

/**
 * Update a chat summary
 */
export async function updateChatSummary(
  chatId: ChatId,
  updates: Partial<Omit<ChatSummary, 'id' | 'chatId' | 'userId' | 'createdAt'>>
): Promise<ChatSummary> {
  try {
    const client = getSupabaseClient();
    const now = new Date().toISOString();

    const { data, error } = await client
      .from('meridian_chat_summaries')
      .update({
        ...(updates.summary !== undefined && { summary: updates.summary }),
        ...(updates.keyTopics !== undefined && { key_topics: updates.keyTopics }),
        ...(updates.keyDecisions !== undefined && { key_decisions: updates.keyDecisions }),
        ...(updates.keyEntities !== undefined && { key_entities: updates.keyEntities }),
        ...(updates.openThreads !== undefined && { open_threads: updates.openThreads }),
        ...(updates.summarizedThroughCount !== undefined && {
          summarized_through_count: updates.summarizedThroughCount,
        }),
        updated_at: now,
      })
      .eq('chat_id', chatId)
      .select()
      .single();

    if (error) {
      throw error;
    }

    return mapChatSummaryRow(data as ChatSummaryRow);
  } catch (error) {
    logger.error('error updating chat summary', error, { op: 'updateChatSummary' });
    throw error;
  }
}
